// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  AssignCoachingModalOrderFragmentDoc,
  AssignCoachingModalCoachingRelationshipFragmentDoc,
} from './AssignCoachingModal.generated';
export type AssignCoachingCardOrderFragment = {
  __typename?: 'Order';
  submittedAt?: number | null;
  id: string;
  createdAt: number;
  subscriptionOrder?: {
    __typename?: 'SubscriptionOrder';
    phaseType?: Types.SkuPhaseType | null;
    timeInMinute: number;
    sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    customerSubscription: {
      __typename?: 'CustomerSubscription';
      id: string;
      nextCreditGrantAt?: number | null;
      sku: {
        __typename?: 'Sku';
        id: string;
        tier: Types.SkuTier;
        family: Types.SkuFamily;
      };
    };
  } | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    tier: Types.SkuTier;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
    };
  };
  packageOrder?: {
    __typename?: 'OfferingPackage';
    id: string;
    name: string;
    slug?: string | null;
    imageLink?: string | null;
    prices?: Array<{
      __typename?: 'OfferingPackagePrice';
      sku?: string | null;
      tier?: Types.SkuTier | null;
      packageCoachingTime?: {
        __typename?: 'PackageCoachingTime';
        exactTimeInMinute?: number | null;
        estimate?: {
          __typename?: 'IntRange';
          start?: number | null;
          end?: number | null;
        } | null;
      } | null;
    }> | null;
    category?: { __typename?: 'Category'; id: string; slug: string } | null;
  } | null;
  hourlyOrder?: {
    __typename?: 'HourlyOrder';
    timeInMinute: number;
    sku?: { __typename?: 'Sku'; id: string; tier: Types.SkuTier } | null;
  } | null;
};

export type AssignCoachingCardCoachingRelationshipFragment = {
  __typename?: 'CoachingRelationship';
  tier?: Types.SkuTier | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
    coachingTimeSummary?: {
      __typename?: 'CoachingTimeSummary';
      totalActiveTime: number;
    } | null;
  };
  categories?: Array<{
    __typename?: 'Category';
    id: string;
    slug: string;
  }> | null;
};

export const AssignCoachingCardOrderFragmentDoc = gql`
  fragment AssignCoachingCard_Order on Order {
    ...AssignCoachingModal_Order
    submittedAt
    subscriptionOrder {
      phaseType
      sku {
        id
        family
      }
    }
  }
  ${AssignCoachingModalOrderFragmentDoc}
`;
export const AssignCoachingCardCoachingRelationshipFragmentDoc = gql`
  fragment AssignCoachingCard_CoachingRelationship on CoachingRelationship {
    ...AssignCoachingModal_CoachingRelationship
  }
  ${AssignCoachingModalCoachingRelationshipFragmentDoc}
`;
